import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

// pages
import Login from "../pages/login";
import XplanTable from "../pages/tables/XplanTable";
import PullListWorkflows from "../pages/tables/PullListWorkflows";
import EditXplan from "../pages/xplans/EditXplan";
import Admin from "../pages/admin";
import DoesNotExist from "../pages/error/DoesNotExist";
import PrivateRoute from "./PrivateRoute";

const ReRoute = () => {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/xplans/new" element={<PrivateRoute><EditXplan /></PrivateRoute>} />
            <Route path="/xplans/:id" element={<PrivateRoute><EditXplan /></PrivateRoute>} />
            <Route path="/xplans" element={<PrivateRoute><XplanTable /></PrivateRoute>} />
            <Route path="/workflows" element={
                <PrivateRoute allowedRoles={[1,2,3,4,5,100]}><PullListWorkflows /></PrivateRoute>
            } />
            <Route path="/admin" element={
                <PrivateRoute allowedRoles={[100]}><Admin /></PrivateRoute>
            } />
            <Route path="/" element={<Navigate to="/xplans" />} />
            <Route path="*" element={<DoesNotExist />} />
        </Routes>
    );
}

export default ReRoute;